export default __webpack_public_path__ + "static/media/ba.24168cd5.svg";